import type { WidgetPriority } from '@frontend/grid-dashboard';

export const defaultWidgetPriority: Record<string, WidgetPriority> = {
  'call-intel-scheduling-opportunities-widget': 'urgent',
  'call-intel-unhappy-calls-widget': 'high',
};
